<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <mat-form-field color="primary">
    <input class="dialog-form-field" matInput [(ngModel)]="data.sourceSystem" maxlength="64"
           placeholder="Source System">
  </mat-form-field>
  <mat-form-field color="primary">
    <input class="dialog-form-field" matInput [(ngModel)]="data.programme" maxlength="64"
           placeholder="Programme">
  </mat-form-field>
  <mat-form-field color="primary">
    <input class="dialog-form-field" matInput [(ngModel)]="data.productType" maxlength="64"
           placeholder="Product Type">
  </mat-form-field>
  <mat-form-field color="primary">
    <input class="dialog-form-field" matInput [(ngModel)]="data.documentType" maxlength="64"
           placeholder="Document Type">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-button [mat-dialog-close]="data" cdkFocusInitial>Ok</button>
</div>
